<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <el-card class="mb15">
            <el-row>
                <el-col :span="8" class="mb0">
                    <el-button v-has-btn="'1,2,3,4,5'" type="primary" @click="handleCreate">创建课程</el-button>
                </el-col>
                <el-col :span="16" class="mb0">
                </el-col>
            </el-row>
        </el-card>
        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="50px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="五馆">
                            <el-select clearable @change="pageHumanityCourse()" v-model="queryParams.museumKey" placeholder="请选择">
                                <el-option v-for="item in museumList"  :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12" class="mb0">

                    </el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.courseName" placeholder="请输入课程名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 350px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="100px" align="center" label="封面" prop="courseCover">
                        <template #default="scope">
                            <img @click="handleDetail(scope.row)" alt="" :src="scope.row.courseCover" width="60" height="36" class="cursor"/>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" align="center" label="所属馆" prop="museumKeyName">
                    </el-table-column>
                    <el-table-column width="200px" align="center" label="课程名称" prop="courseName">
                        <template #default="scope">
                            <div @click="handleDetail(scope.row)" :title="scope.row.courseName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.courseName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="240px" align="center" label="课程简介" prop="introduction">
                        <template #default="scope">
                            <div :title="scope.row.introduction" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.introduction }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="创建时间" prop="createTime">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.createTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="handleUpdate(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="pageHumanityCourse" />
            </div>
        </el-card>
    </div>
</template>

<script>

import {queryDict} from "@/api/admin/public";
import {pageHumanityCourse} from "@/api/admin/humanityCourse";
import {timestampToTime} from "@/utils/date";

export default {
    components: {},
    name: "humanityCourseManager",
    data() {
        return {
            timestampToTime,
            museumList:[],
            total: 0,
            pageCount:0,
            dataList: [],
            loading: true,
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                museumKey:'',
                courseName:'',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.pageHumanityCourse();
    },
    mounted(){},
    methods: {
        queryDict() {
            queryDict({ code: 'museum_info' }).then(res => {
                if (res.data.code === 1) {
                    this.museumList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        pageHumanityCourse(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageHumanityCourse(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
                this.loading = false;
            })
        },
        handleQuery() {
            this.pageHumanityCourse()
        },
        handleCreate(){
            this.$router.push({
                path: "/humanityCourseCreate",
            });
        },
        handleUpdate(row) {
            this.$router.push({
                path: "/humanityCourseCreate",
                query: {
                    courseId: row.courseId,
                }
            });
        },
        handleDetail(row) {
            this.$router.push({
                path: "/humanityCourseDetail",
                query: {
                    courseId: row.courseId,
                }
            });
        }
    }
}

</script>

<style scoped>
.parent-container{
    height: calc(100vh - 85px);
    width: 100%;
    overflow-x: hidden!important;
    box-sizing: border-box;
    display: flex;
}
</style>